import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MijnTokensBrowserAnalyticsService } from '../analytics/analytics.service';
import { MijnTokensBrowserNavigation } from '../mijn-tokens-browser.navigation';
import { MijnTokensBrowserService } from '../mijn-tokens-browser.service';

/**
 * @module PincodeWrapperModule
 * @ngdoc component
 * @name PincodeWrapperComponent
 */
@Component({
    selector: 'tokens-browser-pincode-wrapper',
    templateUrl: 'pincode.wrapper.component.html',
    standalone: false
})
export class PincodeWrapperComponent implements OnInit {
    public constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly analyticsService: MijnTokensBrowserAnalyticsService,
        private readonly navigation: MijnTokensBrowserNavigation,
        private readonly mijnTokensBrowserService: MijnTokensBrowserService
    ) {}

    public ngOnInit(): void {
        this.navigation.init(this.activatedRoute.parent);
        this.sendFormStepAnalytics();
    }

    public onEditPincode(pincode: string): void {
        this.mijnTokensBrowserService.setPincode(pincode);
        this.navigation.toVerifyPincode();
    }

    public onBack(): void {
        this.navigation.toStart();
    }

    private sendFormStepAnalytics(): void {
        this.analyticsService.pushFormStepAnalytics(MijnTokensBrowserNavigation.PINCODE, 1, 'start');
    }
}
